// Утилиты для работы с часовыми поясами
export const TIMEZONES = {
  "Europe/Moscow": "Москва (UTC+3)",
  "Europe/Samara": "Самара (UTC+4)",
  "Asia/Yekaterinburg": "Екатеринбург (UTC+5)",
  "Asia/Omsk": "Омск (UTC+6)",
  "Asia/Krasnoyarsk": "Красноярск (UTC+7)",
  "Asia/Irkutsk": "Иркутск (UTC+8)",
  "Asia/Yakutsk": "Якутск (UTC+9)",
  "Asia/Vladivostok": "Владивосток (UTC+10)",
  "Asia/Magadan": "Магадан (UTC+11)",
  "Asia/Kamchatka": "Камчатка (UTC+12)",
  "Europe/Kaliningrad": "Калининград (UTC+2)",
  "Asia/Tashkent": "Ташкент (UTC+5)",
  "Asia/Almaty": "Алматы (UTC+6)",
  "Europe/Minsk": "Минск (UTC+3)",
  "Europe/Kiev": "Киев (UTC+2)"
};

/**
 * Получить текущее время в локальном часовом поясе браузера
 */
export const getCurrentLocalDateTime = () => {
  return new Date();
};

/**
 * Форматировать дату/время с учетом конкретного часового пояса
 * @param {string|Date} dateInput - строка даты или объект Date
 * @param {string} timezone - часовой пояс (по умолчанию - локальный)
 * @param {boolean} includeTime - включать ли время (по умолчанию true)
 */
export const formatDateTimeInTimezone = (dateInput, timezone = null, includeTime = true) => {
  if (!dateInput) return "";
  
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "Некорректная дата";
  
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  
  if (includeTime) {
    options.hour = "2-digit";
    options.minute = "2-digit";
  }
  
  // Если часовой пояс не указан, используем локальный часовой пояс браузера
  if (timezone && TIMEZONES[timezone]) {
    options.timeZone = timezone;
  } else {
    options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  
  return date.toLocaleString("ru-RU", options);
};

/**
 * Форматировать дату/время в часовом поясе Екатеринбурга (системный часовой пояс)
 * @param {string|Date} dateInput - строка даты или объект Date
 * @param {boolean} includeTime - включать ли время (по умолчанию true)
 */
export const formatLocalDateTime = (dateInput, includeTime = true) => {
  if (!dateInput) return "";
  
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "Некорректная дата";
  
  // Всегда показываем время в часовом поясе Екатеринбурга
  // Это решает проблему когда у пользователя браузер настроен на Moscow, 
  // а система работает в Yekaterinburg
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Asia/Yekaterinburg"  // Принудительно используем системный часовой пояс
  };
  
  if (includeTime) {
    options.hour = "2-digit";
    options.minute = "2-digit";
    options.second = "2-digit";
  }
  
  return date.toLocaleString("ru-RU", options);
};

/**
 * Получить название часового пояса браузера
 */
export const getBrowserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/**
 * Получить красивое название часового пояса
 * @param {string} timezone - идентификатор часового пояса
 */
export const getTimezoneDisplayName = (timezone) => {
  return TIMEZONES[timezone] || timezone || "Локальное время";
};

/**
 * Создать новую дату с текущим временем для формы
 * Используется для инициализации полей дат в формах
 * Возвращает локальное время без смещения UTC
 */
export const createFormDateTime = () => {
  // Просто возвращаем текущую дату без дополнительной обработки
  // Так же как работает поле "Конец"
  const now = new Date();
  
  return now;
};
